import { dataSizeSet, groupSet, reportTitlesSet } from './actions/userActions';
import {
    fetchDataSize,
    fetchReportTitles,
    saveGroup,
    saveDataSize,
    saveReportTitles,
    fetchGroup,
    fetchSelectedLayoutId,
} from './localStorage';
import throttle from 'lodash/throttle';
import groupHeadingApi from './components/orders/OrderHeadings';
import { selectLayout } from 'store/feature/layoutsSlice';

const DEFAULT_DATA_SIZE = 0.5;

export function configureGridGroupStorageWatch(store) {
    let lastGroupSaved;
    let lastDataSize;
    let lastReportTitles;

    store.subscribe(
        //throttle the save behaviour so we don't write to local storage too often
        //(avoids JSON.stringify overuse)
        throttle(() => {
            const {
                user: { group, dataSize, reportTitles },
            } = store.getState();

            //don't update local storage if the items haven't changed since the last save
            //(this subscription is triggered on any state change, not just when groupId is updated)

            if (group !== lastGroupSaved) {
                saveGroup(group);
                lastGroupSaved = group;
            }
            if (dataSize !== lastDataSize) {
                saveDataSize(dataSize);
                lastDataSize = dataSize;
            }
            if (reportTitles !== lastReportTitles) {
                saveReportTitles(reportTitles);
                lastReportTitles = reportTitles;
            }
        }, 1000)
    );
}

export function configureDefaultGroupsAndGrid(
    groups,
    retainedGroupId,
    dispatch
) {
    try {
        if (groups && groups.length > 0) {
            //temporary until proper defaults are made - ensure all user groups have defaults
            groupHeadingApi.ensureGroupsHaveDefaults(groups.map((g) => g.id));

            const lastGroup = fetchGroup();
            if (lastGroup) {
                dispatch(groupSet(lastGroup));
            } else {
                const group =
                    groups.find((x) => x.id == retainedGroupId) ?? groups[0];
                dispatch(groupSet(group));
            }

            const lastDataSize = fetchDataSize();

            let dataSize = lastDataSize
                ? lastDataSize
                : { value: DEFAULT_DATA_SIZE };

            dispatch(dataSizeSet(dataSize));

            const reportTitles = fetchReportTitles();
            if (reportTitles) {
                dispatch(reportTitlesSet(reportTitles));
            }
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export function configureSelctedLayout(store, dispatch) {
    const allLayouts = store.getState().layouts.allLayouts;
    const selectedLayoutId = fetchSelectedLayoutId();
    if (selectedLayoutId) {
        dispatch(selectLayout({ id: selectedLayoutId }));
    } else {
        const preferredLayout = allLayouts.find((l) => l.isPreferred === true);
        const layoutId = preferredLayout?.id ?? allLayouts[0]?.id;
        if (layoutId) {
            dispatch(selectLayout({ id: layoutId }));
        }
    }
}
